class MacAddressUtils {
    MAC_ADDRESS_REGEX = /^([0-9A-Fa-f]{2}:?){5}([0-9A-Fa-f]{2})$|^$/;

    isMacAdrress(source: string) {
        return RegExp(this.MAC_ADDRESS_REGEX).test(source);
    }
}
export default new MacAddressUtils();
